import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  // Label,
  // Legend,
  ResponsiveContainer,
} from "recharts";
import { priceResult, formatKR } from "@assets/utils/check";
import dayjs from "dayjs";

const CustomTooltip = ({ active, payload, label, text }) => {
  const newData = dayjs(label).format("YY.MM.DD");
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 15,
          paddingRight: 15,
          backgroundColor: "white",
          border: "1px solid #EEEEEF",
          borderRadius: "5px",
        }}
      >
        <div
          className="label"
          style={{
            fontSize: 14,
            fontWeight: 500,
          }}
        >
          {newData}
        </div>
        <div
          style={{
            fontSize: 14,
          }}
        >
          {text} : {priceResult(payload[0].value)}
        </div>
      </div>
    );
  }

  return null;
};

const NewChart = ({ chartData, text }) => {
  const ceil_2 = Math.ceil(chartData.length / 6);
  const dataNoCheck = chartData.length === 0 || !chartData ? true : false; // 데이터 유뮤 체크
  return (
    <Grid sx={{ width: 600, height: 400 }}>
      {!dataNoCheck ? (
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            width={500}
            height={300}
            data={chartData}
            margin={{
              top: 2,
              left: 8,
              right: 5.25,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="name"
              axisLine={true}
              tickLine={false}
              style={{
                fontSize: "12px",
              }}
              domain={["dataMin", "dataMax"]}
              allowDecimals={false}
              interval={ceil_2}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              style={{
                fontSize: "12px",
              }}
              tickFormatter={formatKR}
            ></YAxis>
            <Tooltip
              content={<CustomTooltip text={text} />}
              cursor={{ fill: "#F6F6F8" }}
            />
            {/* <Legend /> */}
            <Line
              type="monotone"
              dataKey="pv"
              stroke="#8884d8"
              activeDot={{ r: 8 }}
            />
            <Line type="monotone" dataKey="total" stroke="#129BFF" />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ height: "100%" }}
        >
          <Typography sx={{ fontSize: 14, color: "#9A9A9B" }}>
            데이터 없음
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default NewChart;
